// © Microsoft Corporation. All rights reserved.
/**
 * Helper to parse a JSON string to the corresponding object/value, optionally casting
 * it to the preferred type.
 * @param jsonString - The json string to parse
 * @returns The parse object value or null if the string is not valid or failed to parse.
 */
export function tryParseJson(jsonString) {
    try {
        if (jsonString) {
            return JSON.parse(jsonString);
        }
        // eslint-disable-next-line no-empty
    }
    catch (ex) { }
    return null;
}
//# sourceMappingURL=TryParseJson.js.map